/**
 * ContactConfirmBanner — sticky banner that appears after a coach clicks
 * an email link on a lead. Asks "did you send it?" so we can mark them as
 * contacted without losing reliability to "I'll click it later" amnesia.
 */
import { Check, X, Loader2, Mail } from "lucide-react";

export default function ContactConfirmBanner({ tracker }) {
    const { pending, busy, confirm, dismiss } = tracker;
    if (!pending) return null;
    return (
        <div
            data-testid="contact-confirm-banner"
            className="fixed bottom-4 inset-x-4 z-50 max-w-md mx-auto bg-zinc-950 border border-brand-red rounded-xl shadow-2xl shadow-brand-red/20 overflow-hidden animate-in fade-in slide-in-from-bottom-2"
        >
            <div className="px-5 py-4 flex items-start gap-3">
                <div className="w-9 h-9 rounded-full bg-brand-red/15 border border-brand-red/40 flex items-center justify-center shrink-0">
                    <Mail className="w-4 h-4 text-brand-red" />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="text-sm text-white">
                        Did you send the email to <strong className="text-brand-red">{pending.name || "this lead"}</strong>?
                    </div>
                    <div className="text-[11px] text-zinc-400 mt-0.5">
                        Tap Yes to mark them as contacted — keeps your roster tidy and timestamps everything.
                    </div>
                </div>
            </div>
            <div className="px-5 pb-4 flex items-center gap-2">
                <button
                    type="button"
                    data-testid="contact-confirm-yes"
                    onClick={() => confirm()}
                    disabled={busy}
                    className="flex-1 inline-flex items-center justify-center gap-1.5 text-xs tracking-[0.15em] uppercase px-4 py-2.5 border border-brand-red bg-brand-red text-white hover:bg-brand-red/90 transition-colors disabled:opacity-60"
                >
                    {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />}
                    Yes, mark contacted
                </button>
                <button
                    type="button"
                    data-testid="contact-confirm-no"
                    onClick={dismiss}
                    disabled={busy}
                    className="text-xs tracking-[0.15em] uppercase px-3 py-2.5 border border-zinc-800 text-zinc-300 hover:border-zinc-600 inline-flex items-center gap-1.5"
                >
                    <X className="w-3.5 h-3.5" /> Skip
                </button>
            </div>
        </div>
    );
}
